<!--
 * @Descripttion: 本文件是
 * @Author: MZFE_George
 * @Date: 2020-05-15 10:29:53
 * @LastEditors: MZFE_George
 * @LastEditTime: 2020-07-01 14:44:24
-->
<style lang="less">
.vc-alert {
  position: fixed;
  z-index: 10;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  .vc-alert-layer {
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.3);
    position: absolute;
  }
  .vc-alert-wrap {
    height: auto;
    width: 280px;
    margin: auto;
    margin-top: 150px;
    border-radius: 3px;
    position: relative;
    background: #fff;
    .vc-alert-content {
      text-align: center;
      font-size: 15px;
      padding: 25px 10px;
    }
    .vc-alert-ok {
      text-align: center;
      font-size: 15px;
      padding: 14px 10px;
      border-top: 0.5px solid rgb(237, 237, 237);
    }
  }
}
</style>
<template>
  <div class="vc-alert" v-show="visible">
    <div class="vc-alert-layer"></div>
    <div class="vc-alert-wrap">
      <div v-show="title" class="vc-alert-title">{{ title }}</div>
      <div class="vc-alert-content">{{ aContent }}</div>
      <div class="vc-alert-ok" @click="confirm">{{ btnName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['aVisible', 'aTitle', 'aContent', 'aBtnName'],
  data() {
    return {
      visible: !!this.aVisible,
      title: this.aTitle,
      btnName: this.aBtnName || '好',
    }
  },
  watch: {
    aVisible: function() {
      this.visible = !!this.aVisible
    },
  },
  methods: {
    confirm: function() {
      this.visible = false
      this.$emit('clickOk')
    },
  },
}
</script>
